import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ComponentWillMountSymbol } from 'feature-components'
import {
	BuilderComponentLoaderSymbol,
	BuilderComponentRegistrarSymbol,
	BuilderComponentResolverSymbol,
} from './symbols'
import { PlatformEnvDataProviderSymbol, LifeCycle, ImportMapProviderSymbol } from '@wix/thunderbolt-symbols'
import { builderComponentWillMount } from './builderComponentWillMount'
import { builderComponentPageEnvDataProvider } from './builderComponentPageEnvDataProvider'
import { builderComponentRegistrar } from './builderComponentRegistrar'
import { builderComponentLoader } from './builderComponentLoader'
import { builderComponentResolver } from './builderComponentResolver'
import { BuilderComponentPresetsPolyfillPageLifecycle } from './resizeObserverPageLifecycle'
import { BuilderComponentPresetsPolyfillMutationObserverPageLifecycle } from './mutationObserverPageLifecycle'
import { builderComponentImportMapProvider } from './importMapProvider'
import { presetsPolyfillReporter } from './presetsPolyfillReporter'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(builderComponentWillMount)
	bind(LifeCycle.PageWillMountHandler, LifeCycle.PageWillUnmountHandler).to(
		BuilderComponentPresetsPolyfillPageLifecycle
	)
	bind(LifeCycle.PageWillMountHandler, LifeCycle.PageWillUnmountHandler).to(
		BuilderComponentPresetsPolyfillMutationObserverPageLifecycle
	)
	bind(PlatformEnvDataProviderSymbol).to(builderComponentPageEnvDataProvider)
}

export const site: ContainerModuleLoader = (bind) => {
	bind(BuilderComponentLoaderSymbol).to(builderComponentLoader)
	bind(BuilderComponentRegistrarSymbol).to(builderComponentRegistrar)
	bind(BuilderComponentResolverSymbol, PlatformEnvDataProviderSymbol).to(builderComponentResolver)
	bind(ImportMapProviderSymbol).to(builderComponentImportMapProvider)
	bind(LifeCycle.AppWillMountHandler).to(presetsPolyfillReporter)
}

export * from './types'
export * from './symbols'
export * from './constants'
export type { BuilderComponentsHierarchyHandlerApi } from './ds/compTypeToAllDescendantsHandler'
export type { IMarkBuilderComponentsAsDeadHandler } from '@wix/thunderbolt-symbols'
export { MarkBuilderComponentsAsDeadHandlerSymbol } from '@wix/thunderbolt-symbols'
